


































































































































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { each, isInteger } from 'lodash'
import { camelizeKeys } from '@/utils'

import Process from '@/components/workflow/Process.vue'
import Task from '@/components/workflow/Task'
import Measures from '@/survey/Measures.vue'
import Steps from '@/survey/elements/Steps.vue'
import { kebabToCamelCase } from '@/utils'
import AssessmentMixin from './AssessmentMixin'
import { Process as ProcessType } from '@/store/workflow/types'
import DisclosureSexual from '@/survey/measures/disclosure/DisclosureSexual.vue'

export default mixins(AssessmentMixin).extend({
  components: {
    Bdi2: require('@/survey/measures/bdi2/Bdi2.vue').default,
    Cdrisk10: require('@/survey/measures/cdrisk10/CD-Risk10.vue').default,
    Disclosure: require('@/survey/measures/disclosure/Disclosure.vue').default,
    DisclosureSexual: require('@/survey/measures/disclosure/DisclosureSexual.vue').default,
    Eurohis: require('@/survey/measures/eurohis/Eurohis.vue').default,
    Evaluation: require('@/survey/measures/evaluation/Evaluation.vue').default,
    Gad2: require('@/survey/measures/gad2/Gad2.vue').default,
    Gad7: require('@/survey/measures/gad7/Gad7.vue').default,
    Sbqr: require('@/survey/measures/suicidal_ideation_and_behaviour/Suicidal_Ideation.vue')
      .default,
    Inep: require('@/survey/measures/inep/Inep.vue').default,
    Itq: require('@/survey/measures/itq/ITQ.vue').default,
    Measures,
    Mspss: require('@/survey/measures/mspss/Mspss.vue').default,
    Pathev: require('@/survey/measures/pathev/Pathev.vue').default,
    Pcl5: require('@/survey/measures/pcl5/Pcl5.vue').default,
    Pg13: require('@/survey/measures/pg13/Pg13.vue').default,
    Phq15: require('@/survey/measures/phq15/Phq15.vue').default,
    Phq9: require('@/survey/measures/phq9/Phq9.vue').default,
    Phq4: require('@/survey/measures/phq4/Phq4.vue').default,
    Pmbs: require('@/survey/measures/pmbs/Pmbs.vue').default,
    Taq: require('@/survey/measures/taq/Taq.vue').default,
    Process,
    Steps,
    Task,
    Trgi: require('@/survey/measures/trgi/Trgi.vue').default,
    TgiSrPlus: require('@/survey/measures/tgisrplus/TgiSrPlus.vue').default,
    Wai: require('@/survey/measures/wai/Wai.vue').default,
  },
  props: {
    timeOfMeasurement: {
      type: String,
      validator: (value: string) => ['postwl', 'post', 'fu1', 'fu2'].indexOf(value) > -1,
    },
    inProcess: {
      type: [String, Object],
    },
  },
})
